import React from 'react';
import usePromise from './usePromise';
import { withAbort, withDone } from '../utility/http';
export const useFetch = (fetch) => {
    const [[request, abort], setState] = React.useState(() => withAbort(fetch));
    return [
        React.useMemo(() => withDone(request)(), [request]),
        () => {
            abort();
            setState(withAbort(fetch));
        }
    ];
};
export const useFetchPromise = (fetch) => {
    const [[request, abort], setState] = React.useState(() => withAbort(fetch));
    return [
        usePromise(React.useMemo(() => withDone(request)(), [request])),
        () => {
            abort();
            setState(withAbort(fetch));
        }
    ];
};
export default useFetch;
